<template>
  <div>
    <hero-bar>
      Customer Updates
      <div slot="right" class="customer-update-switch-div">
        <b-switch
          size="is-small"
          :left-label="true"
          v-model="isSentUpdates"
          @input="getSentItems"
          ><span>Show sent customer updates</span>
        </b-switch>
      </div>
      <div slot="right">
        <router-link
          custom
          to="/reportingTracker/customer/update"
          style="color: white"
          class="is-small is-info is-action-text"
          v-slot="{ href, navigate }"
        >
          <div>
            <b-button
              v-if="isAllowedToCreate()"
              type="is-primary"
              :href="href"
              @click="navigate"
            >
              <span class="add-button-right"
                >+ &nbsp;&nbsp;&nbsp;Send New Update</span
              >
            </b-button>
          </div>
        </router-link>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <circul8-table
        :linkEdit="linkEdit"
        :linkView="linkView"
        :listingComponent="true"
        :records="customers"
        :fields="columns"
        :isCheckable="false"
        :maxTextLength="'34'"
        :isLoading="isLoading"
        :backendSortingEnabled="true"
        @backendSort="sortData"
        @querySet="searchByFilter"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
          {{
            currentPage > 0
              ? nextPageCursor
                ? currentPage * 50 - 50 + customers.length
                : totalRecords
              : customers.length
          }}
          records out of {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </section>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
    ></b-loading>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeroBar from "@/components/HeroBar";
import ScopeMixin from "@/mixins/scopeMixin";
import { UserGroup } from "@/services/UserGroups";
import { AuthService } from "@/services/AuthService";
import { Permission } from "../../services/Permissions";
import Circul8Table from "../../components/Circul8Table.vue";
import CustomerUpdatesDataService from "@/services/CustomerUpdatesDataService";
import UtilityMixin from "@/mixins/UtilityMixin";
import * as dayjs from "dayjs";

export default {
  name: "CustomerUpdatesListComponent",
  components: { HeroBar, Circul8Table },
  mixins: [ScopeMixin, UtilityMixin],
  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    created_at: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLoading: true,
      columnTextLen: "34",
      isSentBtn: false,
      isEditBtn: false,
      isSentUpdates: false,
      loadingComponent: null,
      authService: new AuthService(),
      customerupdatesDataService: new CustomerUpdatesDataService(),
      isModalActive: false,
      customers: [],
      newCustomerUpdates: [],
      sentCustomerUpdates: [],
      sentCustomerUpdatesFetched: false,
      checkedRows: [],
      user: [],
      isFullPage: true,
      linkEdit: "reportingtracker.customerUpdateEdit",
      linkView: "reportingtracker.customerUpdateView",
      totalRecords: 0,
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      columns: [
        {
          field: "id",
          label: "ID",
          searchable: true,
          filterKey: { id: "" },
          type: "input"
        },
        {
          field: "subject",
          label: "Subject",
          searchable: true,
          filterKey: { subject: "" },
          type: "input"
        },
        {
          field: "recipient_type",
          label: "Recipient Type",
          searchable: true,
          filterKey: { recipient_type: "" },
          type: "input"
        },
        {
          field: "created_at",
          label: "Created at",
          searchable: true,
          filterKey: { created_at: "" },
          type: "dateField"
        },
        {
          field: "updated_at",
          label: "Updated at",
          searchable: true,
          filterKey: { updated_at: "" },
          type: "dateField"
        },
        {
          field: "created_by",
          label: "Created by",
          searchable: true,
          filterKey: { created_by: "" },
          type: "input"
        },
        {
          field: "updated_by",
          label: "Updated by",
          searchable: true,
          filterKey: { updated_by: "" },
          type: "input"
        },
        {
          field: "status",
          label: "Status",
          searchable: true,
          filterKey: { status: "" },
          type: "input"
        },
        {
          field: "failure_details",
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "failure_details",
          label: "Failure Details",
          searchable: true,
          filterKey: { failure_details: "" },
          type: "input"
        },
        {
          field: "failed_contacts",
          additionalInfo: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "failed_contacts",
          label: "Failed Contacts",
          searchable: true,
          filterKey: { failed_contacts: "" },
          type: "input"
        },
        {
          field: "notif_url",
          label: "Notification URL",
          searchable: true,
          filterKey: { notif_url: "" },
          type: "input",
          uriLink: true
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"])
  },
  mounted() {
    this.checkExternalPermission();
    this.fetchUserData();
    this.fetchContainers();
  },
  watch: {
    users(newValue) {
      this.fetchCustomerUpdatesData(this.query, true);
    }
  },
  methods: {
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.customers = [];
      if (localStorage.getItem("currentReportDefaultView")) {
        this.currentReportDefaultView = localStorage.getItem(
          "currentReportDefaultView"
        );
      }
      this.query = filterQuery + "&";
      this.displayedRecords = 0;

      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "order_field" + "=" + this.lastSortColumn + "&";
        query += "order_by" + "=" + this.lastSortOrder + "&";
        query += this.query;
      } else {
        query = this.query;
      }
      this.fetchCustomerUpdatesData(query, true);
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor
        ? this.nextPageCursor.split("?")[1].split("&")
        : "";
      const query_part =
        temp &&
        temp.filter(function(value) {
          return value.indexOf("page=") == -1;
        });
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.fetchCustomerUpdatesData(this.query, false, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query = query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchCustomerUpdatesData(this.query, false, "prev");
    },
    checkDefaultQueryParamExists(paramValue) {
      const defaultQuery = "default_view" + "=" + paramValue + "&";
      if (this.query.includes(defaultQuery)) {
        return true;
      } else {
        return false;
      }
    },
    replaceDefaultViewParamFromQuery(value) {
      const defaultQuery = "default_view" + "=" + value + "&";

      if (this.checkDefaultQueryParamExists(true)) {
        this.query = this.query.replace(
          "default_view" + "=" + true + "&",
          defaultQuery
        );
      } else if (this.checkDefaultQueryParamExists(false)) {
        this.query = this.query.replace(
          "default_view" + "=" + false + "&",
          defaultQuery
        );
      } else {
        this.query += defaultQuery;
      }
      return this.query;
    },
    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.customers = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      if (localStorage.getItem("currentReportDefaultView")) {
        this.currentReportDefaultView = localStorage.getItem(
          "currentReportDefaultView"
        );
      }

      this.query = this.replaceDefaultViewParamFromQuery(
        this.currentReportDefaultView
      );
      const oldOrderField = "order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "order_field" + "=" + field + "&";
      const newOrderValue = "order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchCustomerUpdatesData(this.query, true);
    },
    getSentItems() {
      this.isLoading = true;
      this.customers = [];
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.query = "";
      this.fetchCustomerUpdatesData(this.query);
    },
    openLoading() {
      this.loadingComponent = this.$buefy.loading.open({
        container: this.isFullPage ? null : this.$refs.element.$el
      });
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    fetchCustomerUpdatesData(query, initialLoad = false, scrollDir) {
      let param = "";
      if (this.isSentUpdates) {
        param = "sent";
      } else {
        param = "all";
      }
      this.isLoading = true;
      this.customerupdatesDataService.getAll(query, param).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }

          if (this.loadMoreClicked || initialLoad)
            this.displayedRecords += response["results"].length;
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            if (!this.nextPageCursor) {
              this.preData = JSON.parse(JSON.stringify(response.results));
              this.prepareCustomerUpdateData(response["results"], 1);
            } else {
              tempData = [...this.customers, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.preData = JSON.parse(JSON.stringify(tempData));
              this.prepareCustomerUpdateData(tempData, 1);
            }
          } else if (scrollDir == "prev") {
            //this.totalRecords = this.data.length + response["count"];
            if (this.currentPage == 0) {
              this.preData = JSON.parse(JSON.stringify(response.results));
              this.prepareCustomerUpdateData(response["results"], 1);
            } else {
              tempData = [...response["results"], ...this.customers];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.preData = JSON.parse(JSON.stringify(tempData));
              this.prepareCustomerUpdateData(tempData, 1);
            }
          } else {
            this.preData = JSON.parse(JSON.stringify(response.results));
            this.prepareCustomerUpdateData(response["results"], 1);
          }
          this.isLoading = false;
        },
        e => {
          this.isLoading = false;
        }
      );
    },
    prepareCustomerUpdateData(customerUpdates, updateType) {
      const customerUpdatesUpdated = [];
      for (const customerUpdate of customerUpdates) {
        customerUpdate["created_at"]
          ? (customerUpdate["created_at"] = dayjs(
              customerUpdate["created_at"]
            ).format("YYYY-MM-DD, HH:mm"))
          : null;

        customerUpdate["updated_at"]
          ? (customerUpdate["updated_at"] = dayjs(
              customerUpdate["updated_at"]
            ).format("YYYY-MM-DD, HH:mm"))
          : null;
        customerUpdate["created_by"] = this.userMap[
          customerUpdate["created_by"]
        ];
        customerUpdate["updated_by"] = this.userMap[
          customerUpdate["updated_by"]
        ];

        // Add url field for uriLink to work
        if (customerUpdate["notif_url"]) {
          customerUpdate["url"] = customerUpdate["notif_url"];
        }

        customerUpdate["actions"] = this.isAdmin();
        customerUpdatesUpdated.push(customerUpdate);
      }
      if (this.nextPageCursor == null) {
        this.customers.push(...customerUpdatesUpdated);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.customers = customerUpdatesUpdated;
      }
      if (updateType == 1) {
        this.newCustomerUpdates = customerUpdatesUpdated;
      } else {
        this.sentCustomerUpdates = customerUpdatesUpdated;
        this.sentCustomerUpdatesFetched = true;
      }
      this.isLoading = false;
    },
    joinStrings(string1, string2, separator) {
      return string1 + (string1 === "" ? "" : separator) + string2;
    },
    dateFormating(dt) {
      let newDate = " - ";
      if (dt == null) {
        return newDate;
      }
      dt = new Date(dt);
      newDate =
        dt.getFullYear() +
        "-" +
        ("0" + (dt.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + dt.getDate()).slice(-2);

      return newDate;
    },
    fieldSorter(fields) {
      return function(a, b) {
        return fields
          .map(function(o) {
            let dir = 1;
            if (o[0] === "-") {
              dir = -1;
              o = o.substring(1);
            }
            if (a[o] > b[o]) return dir;
            if (a[o] < b[o]) return -dir;
            return 0;
          })
          .reduce(function firstNonZeroValue(p, n) {
            return p ? p : n;
          }, 0);
      };
    },
    isAllowedToCreate() {
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      }
      return false;
    },
    isAdmin() {
      if (
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER) ||
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
